

<!-- checkbox in table: https://xaksis.github.io/vue-good-table/guide/advanced/checkbox-table.html#configuration -->
<!-- input tag: https://github.com/matiastucci/vue-input-tag    /   https://tucci.me/vue-input-tag/-->

<template>
  <!-- modal information user -->
  <div class="modal fade" id="modal-select-client" tabindex="-1" style="font: normal 14px FontAwesome; font-size: inherit">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header" style="text-align:center">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h3 class="modal-title">Danh Sách Khách Hàng</h3>
        </div>
        <div class="modal-body">
          <!-- <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <div class="form-group">
                <div class="input-group date">
                  <div class="input-group-addon">
                    <i class="fa fa-book">
                      <label>
                        <span
                          style="margin-left:5px;display:inline-block;"
                        >{{$t('component_address_book.title')}}:</span>
                      </label>
                    </i>
                  </div>
                  <select v-model="address_book_data.group_id" class="form-control" id="status">
                    <option
                      v-for="option in group_address_book"
                      v-bind:value="option.id"
                      :key="option.id"
                    >{{ option.text }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div> -->
          
          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <vue-good-table
                :columns="columns"
                :rows="rows"
                :select-options="{ enabled: true }"
                :search-options="{ enabled: true, placeholder: $t('component_address_book.search') }"
                @on-selected-rows-change="selectionChanged"
                :pagination-options="{
                  enabled: true,
                  nextLabel: $t('component_address_book.next'),
                  prevLabel: $t('component_address_book.prev'),
                  rowsPerPageLabel: $t('component_address_book.rows_per_page'),
                  ofLabel: $t('component_address_book.of'),
                  pageLabel: $t('component_address_book.page'),
                }"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field == 'fullname'">
                    <span>{{getFullName(props.row.firstname, props.row.lastname)}}</span> 
                  </span>
                  <span v-else>
                    {{props.formattedRow[props.column.field]}}
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>

          <div class="row" style="margin-bottom: 10px;">
            <div class="col-sm-12 col-md-12 col-lg-12">
              <!-- <div class="form-group">
                <div class="input-group date">
                  <div class="input-group-addon">
                    <i class="fa fa-envelope-o">
                      <label>
                        <span
                          style="margin-left:5px;display:inline-block;"
                        >{{$t('component_address_book.to')}}:</span>
                      </label>
                    </i>
                  </div>

                  <vue-input-tag v-model="tagsEmail" validate="email"></vue-input-tag>
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-labeled pull-right"
            @click="doSelectClient"
            style="margin-right: 5px;"
          >
            <span class="btn-label">
              <i class="glyphicon glyphicon-ok"></i>
            </span>
            {{$t('common.save')}}
          </button>

          <button
            type="button"
            class="btn btn-default pull-left"
            data-dismiss="modal"
          >{{$t('common.close')}}</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
// import constantsData from "../lib/constantsData";
// import moment from "moment";

// import vue-good-table
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
// vue-input-tag
// import InputTag from "vue-input-tag";
import utils from '@/lib/utils';
import i18n from "../lang";

export default {
  name: "SelectLeaseBackClientsModal",
  props: {
    userId: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    customerId: {
      type: Number,
      default: () => {
        return 0;
      }
    }
  },
  data() {
    return {
      address_book_data: {
        group_id: 1
      },
      list_apartment_lease_back_clients_selected: [],
      group_address_book: [{ id: 1, text: "Public Address Book" }],
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false
      },

      columns: [
        {
          label: this.$t('apartmentbookings.apartment_leaseback_clients.fullname'),
          field: "full_name"
        },
        {
          label: this.$t('apartmentbookings.apartment_leaseback_clients.cmnd_passport'),
          field: "id_passsport"
        },
        {
          label: this.$t('apartmentbookings.apartment_leaseback_clients.email'),
          field: "email"
        },
        {
          label: this.$t('apartmentbookings.apartment_leaseback_clients.phone'),
          field: "phone"
        }
      ],
      rows: [],

      gridDataList: []
    };
  },
  watch: {
    GET_APARTMENT_LEASEBACK_CLIENTS_LIST_DATA: function() {
      this.rows = this.GET_APARTMENT_LEASEBACK_CLIENTS_LIST_DATA;
      return this.gridDataList;
    }
  },
  computed: {
    ...mapGetters([
      "GET_APARTMENT_LEASEBACK_CLIENTS_LIST_DATA"
    ])
  },

  methods: {
    ...mapActions([
      "GET_APARTMENT_LEASEBACK_CLIENTS_LIST"
    ]),

    getFullName(firstname, lastname){
      return utils.getFullName(firstname, lastname, i18n.locale);
    },
    selectionChanged(selectedRows) {
      this.list_apartment_lease_back_clients_selected = selectedRows.selectedRows.map(function(item) {
        return item;
      });
    },
    doSelectClient() {
      // send data to method doSelectClient
      this.$emit("doSelectClient", this.list_apartment_lease_back_clients_selected);
      // hide modal
      $("#modal-select-client").modal("hide");
    }
  },
  mounted() {
    // get all user
    this.GET_APARTMENT_LEASEBACK_CLIENTS_LIST();
  },

  components: {
    "vue-good-table": VueGoodTable,
    // "vue-input-tag": InputTag
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SelectLeaseBackClientsModal.vue